import { TReduxActions } from '../../types/redux';
import { EModalsActionTypes } from '../../actions/modals';

export interface IModalsState {
  ratingInfoModal: {
    show: boolean;
    moderationRulesUrl: string;
  };
}

export const modalsDefaultState = {
  ratingInfoModal: {
    show: false,
    moderationRulesUrl: '',
  },
};

export function modalsReducer(state: IModalsState = modalsDefaultState, action: TReduxActions): IModalsState {
  switch (action.type) {
    case EModalsActionTypes.ToggleRatingInfoModal: {
      return { ...state, ratingInfoModal: { ...state.ratingInfoModal, show: action.payload } };
    }
    default:
      return state;
  }
}
